import {
  extensionDetected,
  extensionNotDetected
} from "../actions/otherActions";
import { getExtensionVersion } from "../utils/eventsEmitter";

const EXTENSION_DETECTION_TIMEOUT = 1000;

//Extension detection uses old way (see create_plugin_detected_div function below).
//Desired state is to use new way of detection, using events emitter (getExtensionVersion).
//To make it work new extensions needs to be released with /profile2? url support.
export const setupExtensionDetection = ({ store }) => {
  const extensionDetectionTimeout = setTimeout(() => {
    clearInterval(extensionDetectionInterval);
    store.dispatch(extensionNotDetected());
  }, EXTENSION_DETECTION_TIMEOUT);

  //new way of checking extension -> new extension supports this way
  const extensionDetectionInterval = setInterval(() => {
    getExtensionVersion(response => {
      clearInterval(extensionDetectionInterval);
      clearTimeout(extensionDetectionTimeout);
      store.dispatch(extensionDetected(response.versionString));
    });
  }, 100);

  //but portal needs to support also old extensions
  //safely remove with legacy portal removal
  window.create_plugin_detected_div = plugin_version => {
    clearTimeout(extensionDetectionInterval);
    clearTimeout(extensionDetectionTimeout);
    store.dispatch(extensionDetected(plugin_version));
  };
};
